import type {CopilotReviewerRow} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'
import {useCopilotReviewEffortDecision} from './use-copilot-review-effort-decision'
import {useSharedCopilotReviewEffort} from './use-shared-copilot-review-effort'

export function useStagedCopilotReviewEffort(row: CopilotReviewerRow | undefined, enabled = true) {
  const shared = useSharedCopilotReviewEffort()
  const local = useCopilotReviewEffortDecision(shared ? undefined : row)
  const effort = shared ?? local
  return {
    ...effort,
    explicitEffort:
      enabled && row?.requestable && row.reviewEffortOptions.length > 0 ? effort.explicitEffort : undefined,
    captureRequest: () => (enabled && row?.requestable ? effort.captureRequest() : undefined),
  }
}
